import ctl from '@netlify/classnames-template-literals'
import { motion } from 'motion/react'
import type { ReactNode } from 'react'

export function FilterOption({
	children,
	onClick,
	isActive,
	counter,
}: {
	children: ReactNode
	onClick: () => void
	isActive: boolean
	counter?: number
}) {
	return (
		<button
			type="button"
			onClick={onClick}
			aria-pressed={isActive}
			className={ctl(`
				${isActive ? 'text-brand-600' : 'text-grey-800'}
				cursor-pointer whitespace-nowrap relative px-2
				transition-colors
				appearance-none border-none bg-transparent text-left w-full
			`)}
		>
			{isActive
				? (
					<>
						<motion.div
							layoutId="active-asset-library-filter-bar"
							className="absolute inset-y-0 right-[-1px] w-[1px] bg-brand-600 rounded-full"
						/>
						<motion.div
							layoutId="active-asset-library-filter-bg"
							className="absolute inset-0 bg-gradient-to-l from-brand-50 to-brand-50/0"
						/>
					</>
				)
				: null}
			<div className="z-100 relative pr-3 pl-5 py-1.5 text-sm flex items-center justify-between gap-8">
				{children}
				{counter ? <div className="text-xs opacity-50 font-medium">{counter}</div> : null}
			</div>
		</button>
	)
}

export function CollectionsIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14">
			<path
				d="M1.33 1.0101280000000001C0.765464 1.06897 0.266616 1.470616 0.079198 2.0172040000000004C-0.0056700000000000006 2.264738 -0.000644 1.9304599999999998 0.003514 7.056014C0.007308 11.72633 0.007392 11.73928 0.035994000000000005 11.844C0.142338 12.233382 0.35636999999999996 12.539338 0.668976 12.748876000000001C0.818706 12.849228 1.0409700000000002 12.940942 1.230796 12.980716C1.33413 13.002360000000001 11.113732 13.014344 11.347 12.993106C11.536966 12.975816000000002 11.689678 12.936448 11.840402000000001 12.865916C12.22165 12.6875 12.517190000000001 12.36137 12.639564 11.984C12.671610000000001 11.885188000000001 13.983788 6.642356 13.989444 6.590556C13.991334 6.573196 13.996094000000001 7.7056 14 9.107C14.005222000000002 10.9795 14.007112000000001 10.417204 14.007098 6.986C14.007098 4.41805 14.004984 3.2179 14.002408 4.319C13.998306000000001 6.073018 13.99531 6.30973 13.978202 6.23C13.912486000000001 5.92361 13.647438000000001 5.64046 13.328 5.535362C13.259974 5.51299 13.178382000000001 5.5091540000000006 12.628 5.502518L12.005 5.495 11.997118 4.872C11.988816000000002 4.215764 11.990454 4.233726 11.918648000000001 4.011C11.786572000000001 3.601304 11.403224 3.217844 10.989818 3.081904C10.737384 2.998898 10.92308 3.0047780000000004 8.295868 2.996546L5.88875 2.989 5.774818000000001 2.5340000000000003C5.6453880000000005 2.017148 5.62898 1.962828 5.561136 1.827C5.413324 1.530998 5.174512 1.29787 4.865 1.147398C4.704854 1.069544 4.55588 1.027124 4.375 1.0078880000000001C4.21673 0.9910460000000001 1.4938 0.993048 1.33 1.0101280000000001M1.371006 2.021138C1.232518 2.05849 1.113658 2.158786 1.04657 2.2949360000000003L1.0150000000000001 2.359 1.0150000000000001 7L1.0150000000000001 11.641 1.0493979999999998 11.711C1.0957240000000001 11.805248 1.200948 11.90756 1.298696 11.953368000000001L1.379 11.991 6.328 11.994696000000001C11.229218 11.99835 11.277882 11.998126000000001 11.368 11.970616C11.52088 11.923954 11.642988 11.80067 11.69448 11.641C11.719386 11.563776 12.978 6.532526 12.978 6.5101960000000005C12.978 6.49047 4.827214 6.490932 4.705806 6.510658C4.513712 6.541878 4.367846 6.66729 4.30766 6.853C4.295186 6.8915 4.101902 7.650650000000001 3.8781540000000003 8.540000000000001C3.6327480000000003 9.515408 3.457468 10.185559999999999 3.436384 10.228988000000001C3.394902 10.314402000000001 3.306968 10.399298 3.20376 10.453562C3.137064 10.488632 3.114664 10.49286 2.996 10.492874C2.87749 10.492887999999999 2.8539280000000002 10.488436 2.7797 10.452105999999999C2.616502 10.372207999999999 2.507792 10.214862 2.495598 10.040954000000001C2.48948 9.953510000000001 2.518306 9.83052 2.911552 8.267C3.1439380000000003 7.343 3.3467700000000002 6.5492 3.3622820000000004 6.503C3.516968 6.042302 3.9198180000000002 5.674396000000001 4.417 5.539786L4.529 5.509462 7.763 5.502224L10.997 5.495 10.996524 4.949C10.996062 4.41616 10.995292000000001 4.401096 10.964562 4.323942000000001C10.913476 4.1956880000000005 10.788848 4.073272 10.662175999999999 4.026904C10.630942 4.01548 9.894472 4.009152 8.001 4.004056L5.383 3.997 5.3035499999999995 3.9597599999999997C5.202764 3.9125099999999997 5.103028 3.820922 5.06009 3.736222C5.041484 3.699472 4.95817 3.3956299999999997 4.871846 3.049648C4.786684 2.7083 4.706856 2.3975 4.694452 2.359C4.643478 2.200758 4.521258 2.07669 4.37003 2.029664C4.283776 2.002854 4.237436 2.002028 2.8580300000000003 2.0029380000000003C1.7769220000000001 2.003666 1.4196280000000001 2.0080340000000003 1.371006 2.021138M0.006916 7C0.006916 9.56795 0.008526 10.618468 0.0105 9.3345C0.012474 8.050518 0.012474 5.9494679999999995 0.0105 4.6655C0.008526 3.3815180000000002 0.006916 4.43205 0.006916 7"
				stroke="none"
				fill="currentColor"
				fillRule="evenodd"
				strokeWidth={0.014}
			/>
		</svg>
	)
}
